import { useState } from 'react';
import { SetSnackbarInfoPayloadType } from '../components/Snackbar';

export function useSnackbar() {
  const [snackbarInfo, setSnackbarInfo] = useState<SetSnackbarInfoPayloadType>({
    isOpen: false,
    otherProps: {},
  });

  const toggleSnackbarInfo = (props: SetSnackbarInfoPayloadType) => {
    setSnackbarInfo((prevProps) => ({
      isOpen: props.isOpen,
      otherProps: {
        ...prevProps.otherProps,
        ...props.otherProps,
      },
    }));
  };

  return {
    snackbarInfo,
    setSnackbarInfo,
    toggleSnackbarInfo,
  };
}
